module.exports = __webpack_public_path__ + "static/assets/9ad1e9d8d3f1cb400a2993ce78e8e8b1.png";